import React, { forwardRef }  from 'react';
import {Button, ButtonPassThroughOptions} from 'primereact/button';
import {defaultJmsColor} from "@Utils/colorUtils";
import {useDynamicButtonStyle} from "@Utils/hooks/useDynamicButtonStyle";
import { Properties } from 'csstype';
import {TooltipOptions} from "primereact/tooltip/tooltipoptions";

interface ThemeButtonProps {
  type: 'button' | 'submit';
  children?: any;
  onClick: (event: any) => void;
  icon?: string;
  className?: string;
  pt?: ButtonPassThroughOptions;
  style?: Properties<string | number>;
  tooltip?: string | undefined;
  tooltipOptions?: TooltipOptions | undefined;
  disabled?: boolean;
  iconPos?: 'top' | 'bottom' | 'left' | 'right' | undefined;
  outlined?: boolean;
}

const ThemeButtonLink = forwardRef<HTMLButtonElement, ThemeButtonProps>(
  ({ children, className, type, onClick, icon , pt, style, disabled, iconPos, tooltip, tooltipOptions, outlined}, ref: any) => {
  const themeButtonStyle = useDynamicButtonStyle();
  const buttonColor: any = themeButtonStyle?.background ?? defaultJmsColor;

  return (
    <Button type={type} ref={ref} style={{ color: buttonColor, ...(outlined ? { borderColor: buttonColor } : {}), ...style }} iconPos={iconPos} text={!outlined} outlined={outlined} onClick={onClick} icon={icon} className={className} pt={pt} disabled={disabled} tooltip={tooltip} tooltipOptions={tooltipOptions}>
      {children}
    </Button>
  );
})

export default ThemeButtonLink;
